import React from 'react';
import Header from '../components/Header';
import FactoryGallery from '../components/FactoryGallery';
import Footer from '../components/Footer';

const FactoryGalleryPage = () => {
  return (
    <div className="App">
      <Header />
      <FactoryGallery />
      <Footer />
    </div>
  );
};

export default FactoryGalleryPage;
